export default __webpack_public_path__ + "static/media/subMenu1.c35a7aab.svg";